exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yolcum-nerede-page[data-v-dfd9d41c]{min-height:100vh;background:#f1f3f5}.page-card[data-v-dfd9d41c]{min-height:100vh}.page-toolbar[data-v-dfd9d41c]{-webkit-box-shadow:0 2px 8px rgba(0,0,0,.18);box-shadow:0 2px 8px rgba(0,0,0,.18)}.page-container[data-v-dfd9d41c]{padding-top:22px}.filter-card[data-v-dfd9d41c]{background:#fff;border-radius:4px}.report-table-host[data-v-dfd9d41c]{width:100%}.cell-click-area[data-v-dfd9d41c]{display:block;width:100%;min-height:24px}.pnr-link[data-v-dfd9d41c]{color:#1976d2;text-decoration:underline;cursor:pointer}@media (max-width:960px){.page-container[data-v-dfd9d41c]{padding-top:16px}}", ""]);

// exports
